export type UserRoleType = 'admin' | 'client' | 'agent';

export enum UserRole {
  ADMIN = 'admin',
  CLIENT = 'client',
  AGENT = 'agent',
}
